export default {
  stakeholders: [],
  top: [],
}
